// Commandes sans tournée : cause lue dans le Dispatch (serveur) et piste Geotab rapprochée par le nom du client.
export const UNASSIGNED_REASONS = {
  // Créée avant le dernier calcul du Dispatch, qui ne l'a pas placée.
  removed: { label: "Retirée du Dispatch", color: "#9c3b31" },
  added: { label: "Ajoutée", color: "#3f5585" },
  suspended: { label: "Suspendue", color: "#a86a24" },
  address: { label: "Adresse", color: "#c5524a" },
  unplaced: { label: "Non placée", color: "#475569" },
};

const IGNORED = new Set(["ferme", "fermes", "inc", "ltee", "ltd", "enr", "senc", "membre", "de", "du", "des", "la", "le", "les", "et", "d", "l"]);
const words = text => String(text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()
  .split(/[^a-z0-9]+/).filter(word => word && !IGNORED.has(word) && !/^\d+$/.test(word));

// Arrêts hors plan dont le lieu porte tous les mots du nom du client. L'adresse de la commande ne sert pas :
// elle peut être celle de la coop (ex. Sainte-Rosalie) et non celle de la ferme.
export function geotabStopsFor(order, geotabDay) {
  const wanted = words(order.client_name);
  if (!wanted.length) return [];
  return (geotabDay?.trucks || []).flatMap(truck => (truck.comparison?.off_stops || [])
    .filter(stop => stop.kind === "off" && !stop.switch && stop.place?.name && wanted.every(word => words(stop.place.name).includes(word)))
    .map(stop => ({ truck, stop })));
}

// « Ferme, LM St-Germain, 1685 Rang Saint Joseph, … » → « Ferme LM St-Germain » : le nom avant l'adresse civique.
export function placeName(name) {
  const parts = String(name || "").split(", ");
  const street = parts.findIndex(part => /^\d/.test(part));
  return street > 0 ? parts.slice(0, street).join(" ") : String(name || "");
}
